import * as $ from 'pumpkin.js'

export default function ($el, options) {
  const { target } = options

  if (!target) {
    console.warn('No target specified.')
    return
  }

  const $target = $.qs(target)

  if (!$target) {
    console.warn(`Target '${target}' could not be found.`)
    return
  }

  const handleClick = e => {
    e.preventDefault()
    $target.click()
  }

  $el.addEventListener('click', handleClick)

  return () => {
    $el.removeEventListener('click', handleClick)
  }
}
